<template>
  <div class="address-info order-list padding-x-3">
    <van-image class="order-item-img" :src="(filePrefix + orderItem.itemImageUri)"></van-image>
    <div class="address-content order-item-content">
      <p class="address-content-l color-green">礼品名称：{{ orderItem.itemName }}</p>
      <p class="address-content-l" v-for="(subItemLink, index) in orderItem.subOrderItemList" :key="index">
        礼品：{{ subItemLink.itemName }}</p>
      <p class="address-content-l point-red">
        {{ orderItem.pointTypeName }}：<span>{{ orderItem.pointValue }}</span></p>
    </div>
    <div class="forward-icon-wrapper color-green">x{{ orderItem.itemQuantity }}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    orderItem: {
      type: Object,
      default: () => { }
    },
    isLink: {
      type: Boolean,
      default: false
    }
  },
  components: {},

  data () {
    return {}
  },
  computed: {
    ...mapState({
      filePrefix: state => state.base.ApiEndpoint.fileUrl
    })
  },
  methods: {
  }
}
</script>
<style scoped lang="less">
.address-info {
  font-size: 0.3rem;
  padding: 0.3rem;
  display: flex;
  background-color: #fff;
  align-items: center;
  height: 2rem;

  .address-content {
    flex: 1 1 auto;
    margin: 0 0.4rem;

    .address-content-l {
      margin: 0.2rem 0rem;
    }
  }

  .forward-icon-wrapper {
    width: 0.34rem;
    height: 0.6rem;
    flex: 0 0 auto;
  }
}

.order-list {
  border: 1px solid #fff;
  background-color: #f1f1f1;
  display: flex;
  height: auto;
  margin: 0.3rem 0rem;

  .order-item-img {
    width: 2.8rem;
    height: 2.8rem;

  }

  .order-item-content {
    min-height: 2.8rem;
    height: auto;
    flex: 1;
  }

  .point-red {
    color: #e20015;

    span {
      font-size: 0.4rem;
    }
  }
}

.color-green {
  color: var(--base-green) !important;
}
</style>
